import { useState } from "react";

const useModalState = ({ onOpen = () => {}, onClose = () => {} } = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openModal = (data = null) => {
    setModalData(data);
    setIsOpen(true);
    onOpen(data);
  };

  const closeModal = () => {
    setModalData(null);
    setIsOpen(false);
    onClose();
  };

  return {
    isOpen,
    modalData,
    openModal,
    closeModal,
  };
};

export default useModalState;